/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params) {
  var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
  if (api && typeof api.t === 'function') return api.t(key, params);
  if (typeof module === 'object' && module.exports && typeof require === 'function') {
    var lang = typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl';
    var dict = require('../../json/i18n/' + lang + '/js-runtime.json');
    var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
    return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
  }
  return key;
}

/* Katalog zdrapek (/zdrapki): porownanie, obserwowane i stan filtrow w adresie.
 *
 * FALA 2 (23.09.2026). ES5, bez bibliotek, bez sieci, bez powiadomien.
 * - Czesc czysta (bez DOM) eksportowana jako module.exports (Node, testy
 *   bin/test-zdrapki-narzedzia.js) i window.PEWNIAKI_ZDRAPKI_STAN.
 * - Czesc DOM startuje tylko, gdy istnieja #zdrapki-kafle i #zdrapki-filtry.
 *   Filtrowanie robi skrypt inline szablonu; tu tylko ustawiamy pola
 *   i wywolujemy jego odswiezenie zdarzeniem `change` na formularzu.
 * - Porownanie to neutralna tabela danych emisji: zadnej punktacji,
 *   rekomendacji ani szans. Lista porownania zyje tylko w pamieci.
 * - Obserwowane: localStorage (klucz ponizej), kazdy dostep w try/catch.
 * Tresci wylacznie przez textContent/createElement.
 */
(function (root) {
    'use strict';

    // Dwie pozycje wystarcza do zestawienia, a trzy pozostaja czytelne
    // w tabeli na telefonie i komputerze.
    var LIMIT_POROWNANIA = 3;
    var LIMIT_OBSERWOWANYCH = 200;
    var MAKS_Q = 60;
    var KLUCZ_MAGAZYNU = 'pewniaki.zdrapki.obserwowane.v1';
    var KLUCZ_PROBY = 'pewniaki.zdrapki.proba';
    var KOLEJNOSC = ['q', 'cena', 'status', 'glowne', 'sortuj', 'obserwowane'];
    var WZOR_ID = /^\d{1,9}$/;
    var KLUCZE_TEKSTOW = ['wiersz_nazwa', 'wiersz_numer', 'wiersz_cena', 'wiersz_status',
        'wiersz_wygrana', 'wiersz_glowne', 'wiersz_od', 'brak', 'usun', 'karta',
        'limit', 'jeszcze', 'podpis'];

    /* ------------------------------------------------------------------ */
    /* Czesc czysta                                                       */
    /* ------------------------------------------------------------------ */

    function maWlasne(obj, klucz) {
        return obj !== null && typeof obj === 'object' && Object.prototype.hasOwnProperty.call(obj, klucz);
    }

    function jestTablica(x) {
        return Object.prototype.toString.call(x) === '[object Array]';
    }

    function zawiera(lista, v) {
        for (var i = 0; i < lista.length; i++) {
            if (lista[i] === v) return true;
        }
        return false;
    }

    /* Id zdrapki: string z 1-9 cyfr. Liczba calkowita >= 0 tez przechodzi (jako string). */
    function normalizujId(id) {
        if (typeof id === 'number' && isFinite(id) && id >= 0 && Math.floor(id) === id) id = String(id);
        if (typeof id !== 'string' || !WZOR_ID.test(id)) return null;
        return id;
    }

    /* Tablica unikalnych, poprawnych id, najwyzej 200. Zly JSON / nie tablica -> []. */
    function wczytajListe(tekst) {
        var dane;
        if (typeof tekst !== 'string') return [];
        try {
            dane = JSON.parse(tekst);
        } catch (e) {
            return [];
        }
        if (!jestTablica(dane)) return [];
        var wynik = [];
        for (var i = 0; i < dane.length && wynik.length < LIMIT_OBSERWOWANYCH; i++) {
            var id = normalizujId(dane[i]);
            if (id !== null && !zawiera(wynik, id)) wynik.push(id);
        }
        return wynik;
    }

    function kopiaListy(lista) {
        return jestTablica(lista) ? lista.slice() : [];
    }

    function bez(lista, id) {
        var wynik = [];
        for (var i = 0; i < lista.length; i++) {
            if (lista[i] !== id) wynik.push(lista[i]);
        }
        return wynik;
    }

    /* {lista, wynik:'dodano'|'usunieto'|'limit'}; niepoprawne id -> 'bledne', lista bez zmian.
       Wejscie nie jest mutowane. */
    function przelaczPorownanie(lista, id, limit) {
        var kopia = kopiaListy(lista);
        var n = typeof limit === 'number' && limit > 0 ? Math.floor(limit) : LIMIT_POROWNANIA;
        var czyste = normalizujId(id);
        if (czyste === null) return { lista: kopia, wynik: 'bledne' };
        if (zawiera(kopia, czyste)) return { lista: bez(kopia, czyste), wynik: 'usunieto' };
        if (kopia.length >= n) return { lista: kopia, wynik: 'limit' };
        kopia.push(czyste);
        return { lista: kopia, wynik: 'dodano' };
    }

    /* Nowa lista obserwowanych. Ponad 200 -> odpada najstarsze (z poczatku listy). */
    function przelaczObserwowane(lista, id) {
        var kopia = kopiaListy(lista);
        var czyste = normalizujId(id);
        if (czyste === null) return kopia;
        if (zawiera(kopia, czyste)) return bez(kopia, czyste);
        kopia.push(czyste);
        if (kopia.length > LIMIT_OBSERWOWANYCH) kopia = kopia.slice(kopia.length - LIMIT_OBSERWOWANYCH);
        return kopia;
    }

    function normalizujQ(v) {
        var s = String(v).replace(/[\u0000-\u001f\u007f]/g, ' ');
        s = s.replace(/^\s+|\s+$/g, '');
        if (s.length > MAKS_Q) s = s.slice(0, MAKS_Q).replace(/\s+$/, '');
        return s;
    }

    function dekoduj(s) {
        try {
            return decodeURIComponent(s.replace(/\+/g, ' '));
        } catch (e) {
            return null;
        }
    }

    function pustyStan() {
        return { q: '', cena: '', status: '', glowne: '', sortuj: '', obserwowane: '' };
    }

    /* Stan z query stringa. Tylko wartosci z bialej listy `dozwolone`
       (mapa pole -> tablica wartosci); q: tekst <= 60 znakow po trim (dluzszy
       jest przycinany); obserwowane: tylko '1'. Przy powtorzonym parametrze
       liczy sie pierwsze wystapienie. Nieznane parametry sa pomijane. */
    function czytajZapytanie(search, dozwolone) {
        var wynik = pustyStan();
        var widziane = {};
        if (typeof search !== 'string') return wynik;
        var s = search.charAt(0) === '?' ? search.slice(1) : search;
        if (s.length > 4000) s = s.slice(0, 4000);
        var pary = s.split('&');
        for (var i = 0; i < pary.length; i++) {
            if (!pary[i]) continue;
            var p = pary[i].indexOf('=');
            var klucz = dekoduj(p < 0 ? pary[i] : pary[i].slice(0, p));
            var wartosc = p < 0 ? '' : dekoduj(pary[i].slice(p + 1));
            if (klucz === null || !maWlasne(wynik, klucz) || maWlasne(widziane, klucz)) continue;
            widziane[klucz] = true;
            if (wartosc === null) continue;
            if (klucz === 'q') {
                wynik.q = normalizujQ(wartosc);
            } else if (klucz === 'obserwowane') {
                wynik.obserwowane = wartosc === '1' ? '1' : '';
            } else {
                var lista = maWlasne(dozwolone, klucz) && jestTablica(dozwolone[klucz]) ? dozwolone[klucz] : [];
                if (wartosc !== '' && zawiera(lista, wartosc)) wynik[klucz] = wartosc;
            }
        }
        return wynik;
    }

    /* '' albo '?...'; pomija puste i domyslne; kolejnosc stala. */
    function zbudujZapytanie(stan, domyslne) {
        var czesci = [];
        for (var i = 0; i < KOLEJNOSC.length; i++) {
            var k = KOLEJNOSC[i];
            var v = maWlasne(stan, k) && stan[k] !== null && stan[k] !== undefined ? String(stan[k]) : '';
            if (k === 'q') v = normalizujQ(v);
            if (k === 'obserwowane' && v !== '1') v = '';
            if (v === '') continue;
            if (maWlasne(domyslne, k) && domyslne[k] !== null && domyslne[k] !== undefined && String(domyslne[k]) === v) continue;
            czesci.push(k + '=' + encodeURIComponent(v));
        }
        return czesci.length ? '?' + czesci.join('&') : '';
    }

    var API = {
        LIMIT_POROWNANIA: LIMIT_POROWNANIA,
        LIMIT_OBSERWOWANYCH: LIMIT_OBSERWOWANYCH,
        KLUCZ_MAGAZYNU: KLUCZ_MAGAZYNU,
        wczytajListe: wczytajListe,
        przelaczPorownanie: przelaczPorownanie,
        przelaczObserwowane: przelaczObserwowane,
        czytajZapytanie: czytajZapytanie,
        zbudujZapytanie: zbudujZapytanie,
        // 23.09.2026: ta sama normalizacja dla filtra katalogu i parametru q.
        normalizujQ: normalizujQ
    };

    if (typeof module !== 'undefined' && module && module.exports) module.exports = API;
    if (root && typeof root === 'object' && root.document) root.PEWNIAKI_ZDRAPKI_STAN = API;

    /* ------------------------------------------------------------------ */
    /* Czesc DOM                                                          */
    /* ------------------------------------------------------------------ */

    if (!root || typeof root.document === 'undefined' || !root.document) return;
    var document = root.document;

    function start() {
        var siatka = document.getElementById('zdrapki-kafle');
        var form = document.getElementById('zdrapki-filtry');
        if (!siatka || !form) return;

        /* --- pomocnicze --- */

        function wszystkie(korzen, selektor) {
            return korzen ? Array.prototype.slice.call(korzen.querySelectorAll(selektor)) : [];
        }

        function przodekZ(el, atrybut, granica) {
            while (el && el !== granica && el.nodeType === 1) {
                if (el.hasAttribute(atrybut)) return el;
                el = el.parentNode;
            }
            return null;
        }

        function widoczny(el) {
            while (el && el.nodeType === 1) {
                if (el.hidden) return false;
                el = el.parentNode;
            }
            return !!el;
        }

        function nowy(tag, klasa, tekst) {
            var el = document.createElement(tag);
            if (klasa) el.className = klasa;
            if (tekst !== undefined && tekst !== null) el.textContent = tekst;
            return el;
        }

        function srOnly(tekst) {
            return nowy('span', 'sr-only', tekst);
        }

        function wyslijZmiane() {
            var ev;
            try {
                ev = new root.Event('change', { bubbles: true });
            } catch (e) {
                ev = document.createEvent(jst("ui.4e1f49a9c8ae8a15"));
                ev.initEvent('change', true, false);
            }
            form.dispatchEvent(ev);
        }

        /* --- teksty dla porownania --- */

        var teksty = null;
        (function () {
            var el = document.getElementById('zdrapki-teksty');
            if (!el) return;
            var dane;
            try {
                dane = JSON.parse(el.textContent || '');
            } catch (e) {
                return;
            }
            if (!dane || typeof dane !== 'object' || jestTablica(dane)) return;
            for (var i = 0; i < KLUCZE_TEKSTOW.length; i++) {
                if (typeof dane[KLUCZE_TEKSTOW[i]] !== 'string') return;
            }
            teksty = dane;
        })();

        /* --- katalog --- */

        var katalog = {};      /* id -> element .kafel-pozycja (pierwsze wystapienie) */
        wszystkie(siatka, '[data-zdrapka]').forEach(function (el) {
            var id = normalizujId(el.getAttribute('data-zdrapka'));
            if (id !== null && !maWlasne(katalog, id)) katalog[id] = el;
        });

        function przyciskKafla(id, akcja) {
            return maWlasne(katalog, id) ? katalog[id].querySelector('[data-akcja="' + akcja + '"]') : null;
        }

        /* --- magazyn (localStorage) --- */

        function magazyn() {
            try {
                return root.localStorage || null;
            } catch (e) {
                return null;
            }
        }

        var magazynOk = (function () {
            try {
                var m = magazyn();
                if (!m) return false;
                m.setItem(KLUCZ_PROBY, '1');
                m.removeItem(KLUCZ_PROBY);
                return true;
            } catch (e) {
                return false;
            }
        })();

        var obserwowane = [];
        if (magazynOk) {
            try {
                obserwowane = wczytajListe(magazyn().getItem(KLUCZ_MAGAZYNU));
            } catch (e) {
                obserwowane = [];
            }
        }

        function zapiszObserwowane(lista) {
            try {
                magazyn().setItem(KLUCZ_MAGAZYNU, JSON.stringify(lista));
                return true;
            } catch (e) {
                return false;
            }
        }

        var blokObs = document.querySelector('[data-obserwowane-blok]');
        var infoObs = document.querySelector('[data-obserwowane-info]');
        var brakObs = document.querySelector('[data-obserwowane-brak]');
        var licznikObs = document.querySelector('[data-obserwowane-licznik]');
        var filtrObs = form.querySelector('[data-filtr="obserwowane"]');

        function oznaczObserwowane() {
            var ile = 0;
            wszystkie(document, '[data-zdrapka]').forEach(function (el) {
                var id = normalizujId(el.getAttribute('data-zdrapka'));
                if (magazynOk && id !== null && zawiera(obserwowane, id)) {
                    el.setAttribute('data-obserwowana', '1');
                } else {
                    el.removeAttribute('data-obserwowana');
                }
            });
            for (var id in katalog) {
                if (!maWlasne(katalog, id)) continue;
                var jest = magazynOk && zawiera(obserwowane, id);
                if (jest) ile++;
                var b = przyciskKafla(id, 'obserwuj');
                if (b) b.setAttribute('aria-pressed', jest ? 'true' : 'false');
            }
            if (licznikObs) licznikObs.textContent = String(ile);
        }

        function ustawTrybObserwowanych(gotowe) {
            var ok = magazynOk;
            wszystkie(siatka, '[data-akcja="obserwuj"]').forEach(function (b) { b.hidden = !ok; });
            if (!gotowe) return;
            if (blokObs) blokObs.hidden = !ok;
            if (infoObs) infoObs.hidden = !ok;
            if (brakObs) brakObs.hidden = ok;
        }

        function wylaczObserwowane() {
            var byloFiltra = !!(filtrObs && filtrObs.checked);
            magazynOk = false;
            if (filtrObs) filtrObs.checked = false;
            ustawTrybObserwowanych(true);
            oznaczObserwowane();
            odswiezAkcje();
            if (byloFiltra) wyslijZmiane();
        }

        function przelaczObs(id) {
            if (!magazynOk) return;
            var nowa = przelaczObserwowane(obserwowane, id);
            if (!zapiszObserwowane(nowa)) {
                wylaczObserwowane();
                return;
            }
            obserwowane = nowa;
            oznaczObserwowane();
            if (filtrObs && filtrObs.checked) wyslijZmiane();
        }

        /* --- porownanie --- */

        var sekcja = document.getElementById('zdrapki-porownanie');
        var komunikat = sekcja ? sekcja.querySelector('[data-porownanie-komunikat]') : null;
        var tabela = sekcja ? sekcja.querySelector('[data-porownanie-tabela]') : null;
        var wyczysc = sekcja ? sekcja.querySelector('[data-porownanie-wyczysc]') : null;
        var tytulSekcji = sekcja ? sekcja.querySelector('h2') : null;
        var porownanieOk = !!(teksty && sekcja && komunikat && tabela);
        var porownanie = [];

        function wyczyscWezel(el) {
            while (el.firstChild) el.removeChild(el.firstChild);
        }

        function dane(el, nazwa) {
            return el.getAttribute(nazwa) || '';
        }

        function bezpiecznyUrl(el) {
            var u = dane(el, 'data-url');
            if (!/^(\/(?!\/)|https?:\/\/)/i.test(u)) {
                var a = el.querySelector('a[href]');
                u = a ? a.getAttribute('href') || '' : '';
                if (!/^(\/(?!\/)|https?:\/\/)/i.test(u)) u = '';
            }
            return u;
        }

        function zbudujTabele() {
            var t = nowy('table', 'tabela');
            // Tabela transponowana (kolumny = zdrapki): main.js nie dokleja do niej
            // automatycznego sortowania kolumn — to znacznik, ktory sam sprawdza.
            t.setAttribute('data-sortowanie-auto', '1');
            t.appendChild(nowy('caption', 'sr-only', teksty.podpis));

            var thead = nowy('thead');
            var tr = nowy('tr');
            var rog = nowy('th', null, teksty.wiersz_nazwa);
            rog.setAttribute('scope', 'col');
            tr.appendChild(rog);
            porownanie.forEach(function (id) {
                var th = nowy('th', null, dane(katalog[id], 'data-tytul'));
                th.setAttribute('scope', 'col');
                tr.appendChild(th);
            });
            thead.appendChild(tr);
            t.appendChild(thead);

            var tbody = nowy('tbody');
            [
                ['wiersz_numer', 'data-numer'],
                ['wiersz_cena', 'data-cena-txt'],
                ['wiersz_status', 'data-status-txt'],
                ['wiersz_wygrana', 'data-wygrana-txt'],
                ['wiersz_glowne', 'data-glowne-txt'],
                ['wiersz_od', 'data-od-txt']
            ].forEach(function (w) {
                var r = nowy('tr');
                var th = nowy('th', null, teksty[w[0]]);
                th.setAttribute('scope', 'row');
                r.appendChild(th);
                porownanie.forEach(function (id) {
                    var v = dane(katalog[id], w[1]).replace(/^\s+|\s+$/g, '');
                    r.appendChild(nowy('td', null, v !== '' ? v : teksty.brak));
                });
                tbody.appendChild(r);
            });

            var ostatni = nowy('tr');
            ostatni.appendChild(nowy('td'));
            porownanie.forEach(function (id) {
                var el = katalog[id];
                var tytul = dane(el, 'data-tytul');
                var td = nowy('td');
                var url = bezpiecznyUrl(el);
                if (url) {
                    var a = nowy('a', null, teksty.karta);
                    a.setAttribute('href', url);
                    a.appendChild(srOnly(': ' + tytul));
                    var p = nowy('p');
                    p.appendChild(a);
                    td.appendChild(p);
                }
                var b = nowy('button', "przycisk przycisk--drugi przycisk--maly", teksty.usun);
                b.setAttribute('type', 'button');
                b.setAttribute('data-porownanie-usun', id);
                b.appendChild(srOnly(': ' + tytul));
                var p2 = nowy('p');
                p2.appendChild(b);
                td.appendChild(p2);
                ostatni.appendChild(td);
            });
            tbody.appendChild(ostatni);
            t.appendChild(tbody);
            return t;
        }

        function odswiezPorownanie() {
            if (!porownanieOk) return;
            for (var id in katalog) {
                if (!maWlasne(katalog, id)) continue;
                var b = przyciskKafla(id, 'porownaj');
                if (b) b.setAttribute('aria-pressed', zawiera(porownanie, id) ? 'true' : 'false');
            }
            wyczyscWezel(tabela);
            if (porownanie.length === 0) {
                komunikat.textContent = '';
                sekcja.hidden = true;
                return;
            }
            sekcja.hidden = false;
            if (porownanie.length === 1) {
                komunikat.textContent = teksty.jeszcze;
                return;
            }
            komunikat.textContent = '';
            tabela.appendChild(zbudujTabele());
        }

        function przelaczPor(id) {
            var r = przelaczPorownanie(porownanie, id, LIMIT_POROWNANIA);
            if (r.wynik === 'limit') {
                sekcja.hidden = false;
                komunikat.textContent = teksty.limit;
                return;
            }
            if (r.wynik === 'bledne') return;
            porownanie = r.lista;
            odswiezPorownanie();
        }

        function fokusPoUsunieciu(id) {
            var b = przyciskKafla(id, 'porownaj');
            if (b && widoczny(b)) {
                b.focus();
                return;
            }
            if (tytulSekcji && widoczny(tytulSekcji)) {
                if (!tytulSekcji.hasAttribute('tabindex')) tytulSekcji.setAttribute('tabindex', '-1');
                tytulSekcji.focus();
            }
        }

        /* --- odslanianie przyciskow na kaflach --- */

        function odswiezAkcje() {
            wszystkie(siatka, '[data-zdrapka-akcje]').forEach(function (blok) {
                var widac = false;
                wszystkie(blok, '[data-akcja]').forEach(function (b) {
                    if (!b.hidden) widac = true;
                });
                blok.hidden = !widac;
            });
        }

        /* --- stan w adresie --- */

        var poleQ = form.querySelector('[data-filtr="nazwa"]');
        var pola = {
            cena: form.querySelector('[data-filtr="cena"]'),
            status: form.querySelector('[data-filtr="status"]'),
            glowne: form.querySelector('[data-filtr="glowne"]'),
            sortuj: form.querySelector('[data-sort]')
        };

        function opcje(select) {
            var w = [];
            if (!select || !select.options) return w;
            for (var i = 0; i < select.options.length; i++) {
                var v = select.options[i].value;
                if (v !== '' && !zawiera(w, v)) w.push(v);
            }
            return w;
        }

        var dozwolone = {
            cena: opcje(pola.cena),
            status: opcje(pola.status),
            glowne: opcje(pola.glowne),
            sortuj: opcje(pola.sortuj)
        };
        var domyslne = {
            sortuj: pola.sortuj && pola.sortuj.options && pola.sortuj.options.length ? pola.sortuj.options[0].value : ''
        };

        function stanFormularza() {
            return {
                q: poleQ ? poleQ.value || '' : '',
                cena: pola.cena ? pola.cena.value || '' : '',
                status: pola.status ? pola.status.value || '' : '',
                glowne: pola.glowne ? pola.glowne.value || '' : '',
                sortuj: pola.sortuj ? pola.sortuj.value || '' : '',
                obserwowane: magazynOk && filtrObs && filtrObs.checked ? '1' : ''
            };
        }

        function zapiszAdres() {
            var h = root.history;
            if (!h || typeof h.replaceState !== 'function') return;
            var loc = root.location;
            try {
                h.replaceState(h.state, '', loc.pathname + zbudujZapytanie(stanFormularza(), domyslne) + loc.hash);
            } catch (e) { /* np. sandbox bez historii */ }
        }

        function wczytajAdres() {
            var stan = czytajZapytanie(root.location ? root.location.search || '' : '', dozwolone);
            if (poleQ && stan.q) poleQ.value = stan.q;
            ['cena', 'status', 'glowne', 'sortuj'].forEach(function (k) {
                if (pola[k] && stan[k]) pola[k].value = stan[k];
            });
            if (filtrObs) filtrObs.checked = magazynOk && stan.obserwowane === '1';
        }

        /* --- start --- */

        ustawTrybObserwowanych(false);
        oznaczObserwowane();

        if (!porownanieOk) {
            wszystkie(siatka, '[data-akcja="porownaj"]').forEach(function (b) { b.hidden = true; });
        } else {
            wszystkie(siatka, '[data-akcja="porownaj"]').forEach(function (b) { b.hidden = false; });
            odswiezPorownanie();
        }

        siatka.addEventListener('click', function (e) {
            var b = przodekZ(e.target, 'data-akcja', siatka);
            if (!b || b.tagName !== 'BUTTON') return;
            var el = przodekZ(b, 'data-zdrapka', siatka);
            if (!el) return;
            var id = normalizujId(el.getAttribute('data-zdrapka'));
            if (id === null) return;
            var akcja = b.getAttribute('data-akcja');
            if (akcja === 'porownaj' && porownanieOk) przelaczPor(id);
            else if (akcja === 'obserwuj') przelaczObs(id);
        });

        if (porownanieOk) {
            tabela.addEventListener('click', function (e) {
                var b = przodekZ(e.target, 'data-porownanie-usun', tabela);
                if (!b) return;
                var id = normalizujId(b.getAttribute('data-porownanie-usun'));
                if (id === null || !zawiera(porownanie, id)) return;
                porownanie = bez(porownanie, id);
                odswiezPorownanie();
                fokusPoUsunieciu(id);
            });
            if (wyczysc) {
                wyczysc.addEventListener('click', function () {
                    var pierwszy = porownanie.length ? porownanie[0] : null;
                    porownanie = [];
                    odswiezPorownanie();
                    if (pierwszy !== null) {
                        var b = przyciskKafla(pierwszy, 'porownaj');
                        if (b && widoczny(b)) b.focus();
                    }
                });
            }
        }

        /* Stan z adresu -> pola, potem odswiezenie filtra inline. Nasluch
           zapisu adresu podpinamy DOPIERO po tym zdarzeniu: sam start nie
           przepisuje adresu (np. nie gubi obcych parametrow przy wejsciu). */
        wczytajAdres();
        wyslijZmiane();

        form.addEventListener('input', zapiszAdres);
        form.addEventListener('change', zapiszAdres);
        form.addEventListener('reset', function () {
            root.setTimeout(zapiszAdres, 0);
        });

        ustawTrybObserwowanych(true);
        odswiezAkcje();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
    } else {
        start();
    }
})(typeof window !== 'undefined' ? window : this);
